import type {
  AccountActivationRequest,
  AccountAuthResponse,
  AccountLoginRequest,
  AccountRegisterAfterPaymentRequest,
  AccountRegisterRequest,
  CheckIsCaptchaRequiredResponse,
} from '@/modules/accounts/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function checkIsCaptchaRequired() {
  const response = await apiClient.get<CheckIsCaptchaRequiredResponse>(
    '/auth/captcha/requirement',
  )

  return response.data
}

async function getRegisterMail(token: string, mode?: string): Promise<string> {
  const response = await apiClient.get(`/auth/register-after-payment`, {
    params: {
      token,
      mode,
    },
  })

  return response.data
}

async function completeRegisterAfterPayment(
  registerData: AccountRegisterAfterPaymentRequest,
): Promise<AccountAuthResponse> {
  const response = await apiClient.post(
    '/auth/register-after-payment',
    registerData,
  )

  return response.data
}

async function login(
  loginData: AccountLoginRequest,
): Promise<AccountAuthResponse> {
  const response = await apiClient.post('/login', loginData, {
    headers: { Authorization: '' },
  })

  return response.data
}

async function logout(): Promise<void> {
  const response = await apiClient.post('/logout')

  return response.data
}

async function register(
  registerData: AccountRegisterRequest,
): Promise<AccountAuthResponse> {
  const response = await apiClient.post('/register', registerData)

  return response.data
}

async function activateAccount(
  accountActivationRequest: AccountActivationRequest,
): Promise<void> {
  const response = await apiClient.put(
    '/activate-account?token=' + accountActivationRequest.token,
    accountActivationRequest,
  )

  return response.data
}

export const authService = {
  getRegisterMail,
  completeRegisterAfterPayment,
  login,
  logout,
  register,
  activateAccount,
  checkIsCaptchaRequired,
}
